module.exports = __webpack_public_path__ + "img/gvt.24fa7f26.svg";